
export const adminDashboardTabs = [
  // {key: "Main"},
  {key: "Students"},
  {key: "Staff"},
  {key: "Courses"}
]


export const parentDashboardTabs = [
  {key: "Main"},
  {key: "Courses"},
  {key: "Payments"},
]

export const staffDashboardTabs = [
  {key: "Main"},
  {key: "Students"},
  {key: "Courses"},
]

